import usFlag from "../assets/images/flags/us.jpg";
import idFlag from "../assets/images/flags/indonesia.png";

const languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  id: {
    label: "Indonesia",
    flag: idFlag,
  },
};

export default languages;
